/**
 * 用于多厅主的不同配置，除了Constant.ts，其他文件不要使用这个文件
 */

let PackageConfig = {
    updatePackageName:"com.kingkong.a696pushb0612",
    WebsiteSign:"prod/heng/A09_696",
    PackageName: "696棋牌",
    // 平台标示符
    PackageFlag: "newPK",
    // 微信appkey
    WeChatAppID: "wx3677d050e10901e0",
    // 默认的客服地址
    CustomerServiceAddress: "https://56f689a05a5b859c.chatnow.mstatik.com/widget/standalone.html?eid=182523",
    // 首页网址
    HomeUrl:"https://b696.cc",

    // 分享链接
    ShareUrl: "https://b696.cc",
    // 服务器地址
    ServerAddresses: [
        "https://api.ghj696.com",
        "https://am.ghj696.com",
        "https://gf.ghj696.com"
    ],
    closeYxd:true,
    // 游戏盾相关
    // 游戏盾相关需要修改
    GameShieldGroupName: "696.2O4v5900Q8.ftnormal01aj.com",
    GameShieldAccessKey: "Frv4Vw-X2HCccyQ2fzla-am7pN1H1stPzXgO9Uu0BUlgp4MZc7RwrrPh_QJdyhRq3gPuNa2dbY2iLncZrKFYl+o0YzjR2PC4c7KIUyrzuWU6i7dJmC1jn5Mu_At7LdJo00PNnhFtu--rKJIIK65ox3RnycFVFGntuToKqg6quKlFw5tC3wBOSXiSqxYApxt587sv2Eb_xu8kOCiJp1+zYEFYtdBYLPsrhheDOOwqYnYI_R-AW-qtAQbhfxWVGQRvoMRp_KEDMngJN9LVFi_JRCMJibb3r8skmxk17Er4cn8a4RMklK_OGOmiAst0H-6BPuFjTuOgKShult8lhnCy14xZ0zp-SjnzC8Em+DZ2B_0",
    GameShieldDomain: "696",
    GameShieldPort: "80",
    InstallSDK: 2,
}

export default PackageConfig
